(ns portal.os-access-modal.request-demo-account
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["src/svg/inform/plus.svg$default" :as Plus]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.advertiser :refer [create-demo-account-mutation]]
            [common.resource.query.user :refer [user-query]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui request-demo-account-controls
  []
  (let [os-context (use-subscribe [:common.os/context])
        sso-token (use-subscribe [:common.os/token])
        user-data (use-query (user-query))
        {{useraccount-id :id} :data} user-data
        {create-demo-account :mutate} (use-mutation (create-demo-account-mutation sso-token))]
    ($ Stack
       {:gap 2
        :sx #js {:py 1
                 :width 450
                 :alignItems "center"}}
       ($ Button
          {:startIcon ($ Plus)
           :variant "contained"
           :disabled (not useraccount-id)
           :sx #js {:width 220}
           :on-click #(create-demo-account {:useraccount-id useraccount-id
                                            :os-context os-context} #js {:onSuccess (fn [] (comment))})}
          "Create Demo Account")
       ($ Button
          {:variant "link"
           :color "text.primary"
           :on-click #(rf/dispatch [:modal/open {:id :os/access-request}])}
          "Request Linking to existing advertiser"))))